module.exports = __webpack_public_path__ + "d4b2e6162293c901f8767421c7aeb2db.MP3";